export default __webpack_public_path__ + "static/media/icon-password.38458629.svg";